<template>
  <responsive-modal v-model="visible" title="Configurar pixel">
    <div class="modal-add-pixel">
      <a
        class="integration-link"
        :href="INFO_MAP[type].link_url"
        target="_blank"
      >
        Conheça o {{ INFO_MAP[type].name }}
        <i class="fa fa-arrow-up-right-from-square" />
      </a>

      <div v-if="step === 1" class="d-flex flex-column gap-4">
        <snow-switch
          v-model="form.is_ga4"
          v-if="type === 'google_analytics'"
          id="is_ga4"
          label="Usar GA4"
        />

        <snow-input
          v-model="form.code"
          id="code"
          label="Id do pixel"
          :errors="errors.code"
        />

        <snow-input
          v-if="customConversionLabel"
          v-model="form.conversion_label"
          id="conversion_label"
          label="Label de conversão do Google Ads"
          :errors="errors.conversion_label"
        />
      </div>

      <second-step
        v-if="step === 2"
        :form="form"
        :errors="errors"
        @update="updateForm"
      />

      <div class="snow-submit-buttons">
        <snow-button
          @click="back"
          size="lg"
          variant="gray"
          :text="step === 2 ? 'Voltar' : 'Cancelar'"
        />
        <snow-button
          size="lg"
          :text="step === 2 ? 'Concluir' : 'Continuar'"
          @click="submit"
          :disabled="!isValid"
        />
      </div>
    </div>
  </responsive-modal>
</template>

<script>
import { formFields } from "@/functions/helpers";
import SecondStep from "./SecondStep.vue";

export default {
  components: { SecondStep },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "facebook"
    },
    customConversionLabel: {
      type: Boolean,
      default: false
    },
    pixel: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      step: 1,
      visible: this.value,
      ...formFields([
        "type",
        "code",
        "is_ga4",
        "value_type",
        "payment_type",
        "fb_api_token",
        "track_purchase",
        "conversion_label",
        "custom_value_config",
        "track_initiate_checkout"
      ])
    };
  },
  computed: {
    INFO_MAP() {
      return {
        facebook: {
          name: "Facebook Ads",
          placeholder: "EX: 12345678901234",
          link_url:
            "https://www.facebook.com/business/help/952192354843755?id=1205376682832142"
        },
        google_ads: {
          name: "Google Ads",
          placeholder: "EX: AW-0123456789",
          link_url: "https://ads.google.com/intl/pt-BR_br/home/"
        },
        google_analytics: {
          name: "Google Analytics",
          placeholder: this.form.is_ga4
            ? "EX: G-1234567890"
            : "EX: UA-123456-00",
          link_url:
            "https://developers.google.com/analytics/devguides/platform?hl=pt-br"
        },
        kwai: {
          name: "Kwai",
          placeholder: "EX: 383231573614893114",
          link_url: "https://www.kwai.com/business"
        }
      };
    },
    isValid() {
      let validCode = this.form.code && this.form.code.length >= 12;
      let validValue = true;

      if (this.form.value_type === "custom_value") {
        let emptyMethod = this.form.custom_value_config.value_by_method.find(
          v => !v.payment_method || !v.value
        );

        if (
          (!this.form.custom_value_config.currency ||
            !this.form.custom_value_config.value_by_method.length ||
            !!emptyMethod) &&
          this.step === 2
        )
          validValue = false;
      }

      return validCode && validValue;
    }
  },
  methods: {
    updateForm(options = {}) {
      this.form = { ...this.form, ...options };
    },
    back() {
      if (this.step === 1) {
        this.visible = false;
      } else this.step -= 1;
    },
    submit() {
      if (this.step === 1) {
        this.step += 1;
        return;
      }

      let newPixel = { ...this.form };
      if (this.pixel !== null) {
        this.$emit("submitEdit", newPixel);
      } else {
        this.$emit("submit", newPixel);
      }
    }
  },
  watch: {
    value(val) {
      this.visible = val;
    },
    visible(val) {
      this.$emit("input", val);

      this.form = {
        code: "",
        type: this.type,
        track_purchase: true,
        track_initiate_checkout: true,
        payment_type: "all",
        value_type: "real_value",
        custom_value_config: {
          currency: "",
          value_by_method: [
            {
              payment_method: "",
              value: ""
            }
          ]
        },
        ...(this.pixel || {})
      };

      this.step = 1;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-add-pixel {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
